function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Select } from '@domain-group/fe-blueprint-ui/select';
import { ListingType } from '@domain-group/fe-allhomes-library';
import { ListingSearchAutocomplete } from '@domain-group/fe-co-allhomes-autocomplete';
import StateLink from '../state-link';
import CommonPropTypes from '../../models/common-prop-types';
import ContainerPropTypes from '../../models/container-prop-types';
import { optionsForListingType } from '../../models/search-options';
import { Hero } from '../hero';
import useSearchHandlers from '../../common/use-homepage-search-handlers';
import * as styles from './desktop.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var getListingType = name => ListingType[name] || ListingType.SALES_RESIDENTIAL;
var DesktopContainer = props => {
  var _useState = useState(getListingType(props.listingType)),
    _useState2 = _slicedToArray(_useState, 2),
    listingType = _useState2[0],
    setListingType = _useState2[1];
  var searchHandlers = useSearchHandlers({
    listingType: listingType.name,
    immediateTypes: ListingSearchAutocomplete.immediateTypes
  });
  useEffect(() => {
    setListingType(getListingType(props.listingType));
  }, [props.listingType]);
  var changeOption = option => {
    setListingType(getListingType(option.value));
    if (props.onOptionChange) {
      props.onOptionChange(option.value);
    }
  };
  var buttonText = props.searchButtonLabel ? props.searchButtonLabel : 'Browse ACT';
  var renderStates = () => {
    var states = [{
      value: 'nsw',
      label: 'NSW'
    }, {
      value: 'vic',
      label: 'VIC'
    }, {
      value: 'qld',
      label: 'QLD'
    }, {
      value: 'tas',
      label: 'TAS'
    }, {
      value: 'sa',
      label: 'SA'
    }, {
      value: 'nt',
      label: 'NT'
    }, {
      value: 'wa',
      label: 'WA'
    }];
    return states.map(state => ___EmotionJSX(StateLink, {
      css: styles.stateLink,
      href: state.value,
      key: state.value,
      browseUrlFormat: props.browseUrlFormat,
      text: state.label,
      onStateSelect: props.onStateSelect
    }));
  };
  var options = optionsForListingType(listingType.name);
  return ___EmotionJSX(Hero, _extends({
    css: styles.container
  }, props.hero), ___EmotionJSX("div", {
    css: styles.stateOptions
  }, ___EmotionJSX(StateLink, {
    css: props.darkButton ? styles.browseAllACTDark : styles.browseAllACTDefault,
    href: "act",
    browseUrlFormat: props.browseUrlFormat,
    text: buttonText,
    onStateSelect: () => {
      props.onStateSelect('ACT');
    }
  }), ___EmotionJSX("div", {
    css: styles.separator
  }), ___EmotionJSX("div", {
    css: styles.stateOptions2(props.hero.applyTextShadow)
  }, "Browse listings in", renderStates())), ___EmotionJSX("div", {
    css: styles.search
  }, ___EmotionJSX(Select, {
    value: listingType.name,
    className: "allhomes-search-frontpage__desktop-search-options-select",
    options: options,
    searchable: false,
    onChange: changeOption,
    clearable: false,
    autosize: true
  }), ___EmotionJSX("div", {
    css: styles.autocompleteShadow
  }, ___EmotionJSX(ListingSearchAutocomplete, _extends({
    css: styles.autocomplete,
    noBorder: true,
    size: "large",
    listingType: listingType.name,
    showRecent: true
  }, searchHandlers, {
    allowDefaultSearch: true
  })))));
};
DesktopContainer.propTypes = _objectSpread(_objectSpread(_objectSpread({}, CommonPropTypes), ContainerPropTypes), {}, {
  hero: PropTypes.shape(),
  darkButton: PropTypes.bool,
  toggledFeatures: PropTypes.objectOf(PropTypes.bool),
  desktop: PropTypes.bool
});
DesktopContainer.defaultProps = {
  darkButton: false,
  hero: undefined,
  toggledFeatures: {},
  desktop: false
};
export default DesktopContainer;